import { DoctorConfig } from '@app/icare/entities/doctor/config'
import { patientDoctorQueries } from '@app/icare/entities/doctor/queries/patientDoctorQueries'
import { PatientDoctorEditDrawer } from '@app/icare/entities/patient/edits/PatientDoctorEditDrawer'
import { patientFindingsQueryOptions } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientDoctorRelation } from '@app/icare/entities/patient/schema/PatientDoctor'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { entityRegistry } from '@app/icare/entities/registry'
import { RelationTabs } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationTabs'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

const { label } = entityRegistry.doctor

export const Route = createFileRoute('/_app/patienten/$id/_edit/_doctor/praxen')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(patientDoctorQueries.forTabs(params.id)),
      queryClient.ensureQueryData(patientFindingsQueryOptions(params.id)),
    ]),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: relations = [] } = useSuspenseQuery(patientDoctorQueries.forTabs(id))
  const { data: findings = [] } = useQuery(patientFindingsQueryOptions(id))
  const { data: totalCount } = useQuery(patientDoctorQueries.totalCount(id))
  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientDoctorRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/praxen/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })
  return (
    <RelationTabs
      relations={relations}
      relationTotalCount={totalCount}
      basePath={`/patienten/${id}/praxen`}
      findings={findings}
      findingsGroup="doctors"
      getLabel={item => DoctorConfig.format.primary(item.to) ?? label}
      onAdd={params =>
        void PatientDoctorEditDrawer.show({
          patientId: id,
          onAfterCommit: handleAfterCommit,
          ...params,
        })
      }
      entity="doctor"
    />
  )
}
